<script setup>
import { ref, onMounted } from 'vue'
import Select from 'primevue/select'
import { dropdownOptionsApi } from '@/api'

const model = defineModel()

const dropdownOptions = ref([])

onMounted(() => {
  dropdownOptionsApi.getReloCompanies().then(({ data }) => { dropdownOptions.value = data })
})
</script>

<template lang="pug">
Select(
  v-model="model"
  :options="dropdownOptions"
  optionLabel="name"
  optionValue="code"
  filter
  showClear
  placeholder="All Relo Companies"
)
</template>
